import { type z } from "zod";
import { violationTypeSchema } from "./uiParts/ViolationType/schema";
import { personInChargeSchema } from "./uiParts/PersonInCharge/schema";
import { documentSubmissionCheckSchema } from "./uiParts/DocumentSubmissionCheck/schema";
import { emailConfirmationSchema } from "./uiParts/EmailConfirmation/schema";
import { clientSelectSectionSchema } from "../ClientSelectSection/schema";

/**
 * 違反報告入力フォーム全体のバリデーションスキーマ
 * 各セクションのスキーマを統合している:
 * - violationTypeSchema: 違反行為の種類選択
 * - clientSelectSectionSchema: 応募先選択
 * - personInChargeSchema: 担当者情報
 * - documentSubmissionCheckSchema: 資料提出可否
 * - emailConfirmationSchema: 連絡先メールアドレス
 */
export const violationReportInputsSchema = violationTypeSchema
  .and(clientSelectSectionSchema)
  .and(personInChargeSchema)
  .and(documentSubmissionCheckSchema)
  .and(emailConfirmationSchema);

/**
 * 違反報告入力フォームの型定義
 * violationReportInputsSchema から自動生成
 */
export type ViolationReportInputsValues = z.infer<typeof violationReportInputsSchema>;
